<template>
  <div class="room-waiting-modal-mobile-component">
    <div class="room-waiting-modal-mobile">
      <div class="room-waiting-modal-mobile-header">
        <button class="room-waiting-modal-mobile-btn back" @click="onClose" />
        <div class="room-waiting-modal-mobile-title">{{ $t("waitingRoom.list.title") }}</div>
      </div>
      <div class="room-waiting-modal-mobile-body">
        <RoomWaitingList />
      </div>
    </div>
  </div>
</template>

<script>
import RoomWaitingList from '@/components/Room/Waiting/List'

export default {
  name: 'RoomWaitingModalMobile',
  components: {
    RoomWaitingList
  },
  methods: {
    onClose() {
      this.$modal('RoomWaitingModalMobile')
    }
  }
}
</script>

<style lang="scss" scoped>
.room-waiting-modal-mobile-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 4;
}
.room-waiting-modal-mobile {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.room-waiting-modal-mobile-header {
  height: 60px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.room-waiting-modal-mobile-btn {
  width: 50px;
  height: 100%;
  position: absolute;
  &.back {
    background: url('~@/assets/images/arrowLineThickLeft_gray.svg') no-repeat center / 18px auto;
    left: 0;
  }
}
.room-waiting-modal-mobile-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}
.room-waiting-modal-mobile-body {
  min-height: 0;
  flex: 1;
  background-color: #eaeaea;
}
</style>